// src/components/AboutUs/AboutUs.js
import React from 'react';
import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';
import './AboutUs.css';
import emreuygun from '../../assets/emreuygun.jpeg';

function AboutUs() {
  return (
    <div className="page-wrapper">
      <Navbar />
      
      {/* Sayfa Üst Başlık Alanı (Hero) */}
      <div className="page-header">
        <div className="page-header-overlay"></div>
        <div className="container">
          <h1 className="page-title">Hakkımda</h1>
          <p className="page-breadcrumb">Ana Sayfa / Hakkımda</p>
        </div>
      </div>

      {/* Ana İçerik Alanı */}
      <section className="about-detail-section">
        <div className="container">
          <div className="about-detail-grid">
            
            {/* Sol Kısım: Fotoğraf */}
            <div className="about-detail-image-box">
              <img 
                src={emreuygun}
                alt="Av. Emre Uygun" 
                className="about-detail-img" 
              />
              <div className="about-detail-frame"></div>
            </div>

            {/* Sağ Kısım: Özgeçmiş ve Metin (Birinci Tekil Şahıs) */}
            <div className="about-detail-content">
              <h2 className="about-detail-heading">Hukuki Sürecinizde <span className="gold-text">Güvenilir Rehberiniz</span></h2>
              <div className="title-underline-left"></div>
              
              <p className="about-detail-text">
                2024 yılında <strong>Çukurova Üniversitesi Hukuk Fakültesi'nden</strong> başarıyla mezun olarak büyük bir tutkuyla bağlı olduğum avukatlık mesleğine adım attım. Meslek hayatım boyunca şeffaflık, dürüstlük ve müvekkil odaklılık ilkelerinden taviz vermeden çalışmalarımı sürdürmekteyim.
              </p>
              
              <p className="about-detail-text">
                Kurucusu olduğum hukuk ve danışmanlık büromda; başta Ceza Hukuku, Aile Hukuku, Ticaret Hukuku ve Gayrimenkul Hukuku olmak üzere birçok farklı alanda bireysel ve kurumsal müvekkillerime nitelikli, şeffaf ve sonuç odaklı avukatlık hizmeti sunuyorum. 
              </p>

              <p className="about-detail-text">
                Temel amacım, karşılaştığınız hukuki ihtilafları yalnızca bir dava dosyası olarak görmek değil; uyuşmazlık öncesi koruyucu avukatlık prensibiyle, sizin için en hızlı ve en lehe olacak şekilde çözüme kavuşturmaktır. Zorlu hukuki süreçlerinizde sadece bir avukat değil, aynı zamanda haklarınızı sonuna kadar savunan güvenilir bir yol arkadaşı olmayı hedefliyorum.
              </p>

              {/* Değerlerimiz Alanı */}
              <div className="core-values">
                <div className="value-item">
                  <div className="value-icon-wrapper">
                    <span className="value-icon">⚖️</span>
                  </div>
                  <h4>Adil Temsil</h4>
                  <p className="value-desc">Hukukun üstünlüğü ilkesiyle haklarınızı şahsen koruyorum.</p>
                </div>
                <div className="value-item">
                  <div className="value-icon-wrapper">
                    <span className="value-icon">🛡️</span>
                  </div>
                  <h4>Mutlak Gizlilik</h4>
                  <p className="value-desc">Tüm süreçlerinizi en yüksek mahremiyetle bizzat yönetiyorum.</p>
                </div>
                <div className="value-item">
                  <div className="value-icon-wrapper">
                    <span className="value-icon">🎯</span>
                  </div>
                  <h4>Sonuç Odaklılık</h4>
                  <p className="value-desc">Davanızda en hızlı ve lehe çözümleri sizin için hedefliyorum.</p>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default AboutUs;